import { render } from "./buy.vue?vue&type=template&id=a93550d4&scoped=true"
import script from "./buy.vue?vue&type=script&lang=js"
export * from "./buy.vue?vue&type=script&lang=js"

import "./buy.vue?vue&type=style&index=0&id=a93550d4&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a93550d4"]])

export default __exports__